import apiClient from "./axiosClient";

export type FeedbackCategory = "Bug" | "FeatureRequest" | "General";

export interface FeedbackSubmitPayload {
  category: FeedbackCategory;
  message: string;
  page?: string;
}

export async function submitFeedback(payload: FeedbackSubmitPayload) {
  await apiClient.post("/feedback", payload);
}
